/* MT · Bestellung ergänzen - Bestellauswahl + Produkt-Picker (page-scoped) */
(function () {
  'use strict';
  // Markiert "JS laeuft". Die :target-Fallbackregel im Konto-CSS darf dann NICHT greifen,
  // sonst haelt sie das Ergaenzen-Panel per !important offen und Schliessen/X tun nichts.
  document.documentElement.classList.add('mt-js');

  var search = document.getElementById('mtbe-search');
  if (!search) return; // nur auf der Bestellung-ergänzen-Seite

  var results = document.getElementById('mtbe-results');
  var selectedWrap = document.getElementById('mtbe-selected');
  var summaryEl = document.getElementById('mtbe-summary');
  var discountEl = document.getElementById('mtbe-discount');
  var artikelField = document.getElementById('mtbe-artikel-field');
  // Ohne diese drei Geschwister-Elemente kann das Modul nicht arbeiten -> sauber abbrechen statt TypeError
  if (!results || !selectedWrap || !artikelField) return;
  var bodyEl = document.getElementById('mtbe-body');
  var form = search.closest('form');

  var orderSelect = document.getElementById('mtbe-order-select');
  var orderManual = document.getElementById('mtbe-order-manual');
  var orderField = document.getElementById('mtbe-order-field');

  // 08.10.2026 (Optik „Bestellung ergänzen“): Symbole kommen aus dem Icon-Satz. Die Section legt sie als <template> ab
  // (mtbe-ic-entfernen, mtbe-ic-plus). Fehlt die Vorlage, bleibt die Ausgabe, wie sie war. Nur Markup, keine Logik.
  function icon(name) { var v = document.getElementById('mtbe-ic-' + name); return v ? v.innerHTML : ''; }
  var IC_ENTFERNEN = icon('entfernen'), IC_PLUS = icon('plus'), IC_MINUS = icon('minus'); // 28.10.2026 (T-716): Minus fürs Mengenfeld, die Vorlage hat nur die Seite

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Texte (08.10.2026, GPT A22): Deutsch und Englisch an einer Stelle ----------
     Seit 19.10.2026 legt das Kundenportal (assets/mt-portal.js) sofort zahlungspflichtig dazu. Greift es nicht, schickt das Formular eine Mail mit der Auswahl,
     danach geht die Rechnung mit Zahlungs-Link raus. Die Aufstellung in der Mail (itemTable, summaryText) bleibt deutsch. */
  var IST_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var TX = IST_EN ? {
    variante: 'Variant', menge: 'Quantity', entfernen: 'Remove', nichts: 'Nothing found.', nichtVerfuegbar: 'Not available',
    summeArtikel: 'Items', versand: 'Shipping', keinVersand: 'no extra shipping', keinVersandKlein: '',
    summeVorlaeufig: 'Provisional total', inklMwst: 'incl. VAT', laedt: 'Prices are still loading …',
    summeHinweis: 'Provisional, because this form does not know your first order. Discount and shipping are shown on the invoice I send you. Only that invoice counts.',
    leer: 'Choose at least one item.',
    nochmalTippen: 'Confirm sending',
    fuerBestellung: 'For order ', moment: 'One moment …', korbLeer: 'Your cart is empty.', uebernommen: 'Added',
    ergAngefragt: 'Items requested', angefragt: 'requested', vonDir: 'Requested by you', artikelEins: 'item', artikelMehr: 'items', uhr: '',
    pendNotiz: 'The payment link is on its way by email.',
    ab: 'from ', weniger: 'Decrease quantity', mehr: 'Increase quantity'
  } : {
    variante: 'Variante', menge: 'Menge', entfernen: 'Entfernen', nichts: 'Nichts gefunden.', nichtVerfuegbar: 'Nicht verfügbar',
    summeArtikel: 'Artikel', versand: 'Versand', keinVersand: 'kein Versand extra', keinVersandKlein: '',
    summeVorlaeufig: 'Vorläufige Summe', inklMwst: 'inkl. MwSt.', laedt: 'Preise werden noch geladen …',
    summeHinweis: 'Vorläufig, weil dieses Formular deine erste Bestellung nicht kennt. Rabatt und Versand stehen in der Rechnung, die ich dir schicke. Erst die gilt.',
    leer: 'Wähl mindestens einen Artikel.',
    nochmalTippen: 'Absenden bestätigen',
    fuerBestellung: 'Für Bestellung ', moment: 'Moment …', korbLeer: 'Dein Warenkorb ist leer.', uebernommen: 'Übernommen',
    ergAngefragt: 'Hinzufügen angefragt', angefragt: 'angefragt', vonDir: 'Von dir angefragt', artikelEins: 'Artikel', artikelMehr: 'Artikel', uhr: ' Uhr',
    pendNotiz: 'Der Zahlungslink kommt per E-Mail.',
    ab: 'ab ', weniger: 'Menge verringern', mehr: 'Menge erhöhen'
  };

  /* ---------- Echter Lieferstatus (08.10.2026, GPT A22-004) ----------
     Vorher stand bei allem Bestellbaren „Auf Lager“. Jetzt kommt je Produkt der Status mit Lieferzeit aus snippets/delivery-status
     (über /products/<handle>?section_id=mt-lieferstatus, in der Sprache der Seite): Sofort lieferbar, Bald verfügbar, Nicht auf Lager,
     Auf Bestellung gefertigt, Vorbestellung mit Datum. Hier steht dafür kein eigener Wortlaut. */
  var LS = {};
  function lsWurzel() { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (IST_EN ? '/en/' : '/'); return r.replace(/\/$/, ''); }
  function holeStatus(handle) {
    if (!handle) return Promise.resolve(null);
    if (!LS[handle]) {
      LS[handle] = fetch(lsWurzel() + '/products/' + encodeURIComponent(handle) + '?section_id=mt-lieferstatus', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var m = { erste: null };
          if (!t) return m;
          var doc = new DOMParser().parseFromString(t, 'text/html');
          Array.prototype.forEach.call(doc.querySelectorAll('[data-mt-lieferstatus] [data-id]'), function (n) {
            var e = { status: n.getAttribute('data-status') || '', label: n.getAttribute('data-label') || '', zeit: n.getAttribute('data-zeit') || '' };
            m[n.getAttribute('data-id')] = e;
            if (!m.erste) m.erste = e;
          });
          return m;
        })
        .catch(function () { delete LS[handle]; return null; });
    }
    return LS[handle];
  }
  function statusHtml(e) {
    if (!e || !e.label) return '';
    var st = String(e.status).replace(/[^a-z_]/g, '');
    var mitZeit = st === 'on_order' || st === 'out_of_stock' || st === 'made_to_order' || st === 'auf_bestellung' || st === 'auslaufend' || st === 'sold_out';
    return '<span class="mtbe-stock mtbe-stock--' + st + '" style="color:var(--mt-st-' + st + ',inherit);line-height:1.3">' + esc(e.label) + (mitZeit && e.zeit ? ' · ' + esc(e.zeit) : '') + '</span>';
  }
  function statusFuer(it) {
    if (!it || !it.ls) return null;
    return it.ls[String(it.variantId)] || it.ls.erste;
  }

  /* ---------- Bestellauswahl <-> verstecktes Feld ---------- */
  function syncOrder() {
    if (!orderSelect || !orderField) return;
    if (orderSelect.value === '__manual__') {
      orderManual.classList.remove('mtbe-hidden');
      orderField.value = (orderManual.value || '').trim();
    } else {
      orderManual.classList.add('mtbe-hidden');
      orderField.value = orderSelect.value || '';
    }
  }
  if (orderSelect) orderSelect.addEventListener('change', syncOrder);
  if (orderManual) orderManual.addEventListener('input', syncOrder);

  // Vorbelegung aus ?order= (z.B. aus dem Konto verlinkt: "Änderung anfragen")
  try {
    var qOrder = new URLSearchParams(location.search).get('order');
    if (qOrder) {
      if (orderSelect) {
        var found = false;
        for (var oi = 0; oi < orderSelect.options.length; oi++) {
          if (orderSelect.options[oi].value === qOrder) { orderSelect.value = qOrder; found = true; break; }
        }
        if (!found) { orderSelect.value = '__manual__'; if (orderManual) orderManual.value = qOrder; }
        syncOrder();
      } else {
        var plain = document.getElementById('mtbe-order');
        if (plain) plain.value = qOrder;
      }
    }
  } catch (e) {}

  /* ---------- ausgewählte Artikel ---------- */
  var items = [];

  function moneyC(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0\u20ac';
  }
  function moneyPlain(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20ac';
  }
  function serialize() {
    // Genau die Tabelle, die auch in der Zusammenfassung steht - sonst kämen in der
    // Kundennachricht zwei verschiedene Auflistungen desselben Warenkorbs an.
    artikelField.value = itemTable();
  }

  function pricingHtml(it) {
    if (typeof it.price !== 'number') return '';
    return '<span class="mtbe-row-price">' + moneyC(it.price) + '</span>';
  }

  // 28.10.2026 (T-716): Mengenfeld wie der Stepper im Warenkorb (Minus, Zahl, Plus). Ohne Minus-Vorlage (Konto) bleibt das Zahlenfeld wie bisher.
  function mengeHtml(it, idx) {
    if (!IC_MINUS || !IC_PLUS) return '<input type="number" class="mtbe-row-qty" min="1" value="' + it.qty + '" data-idx="' + idx + '" aria-label="' + TX.menge + '">';
    return '<div class="mtbe-qty">' +
      '<button type="button" class="mtbe-qty-btn" data-schritt="-1" data-idx="' + idx + '" aria-label="' + TX.weniger + '"' + (it.qty <= 1 ? ' disabled' : '') + '>' + IC_MINUS + '</button>' +
      '<input type="number" class="mtbe-row-qty" min="1" inputmode="numeric" value="' + it.qty + '" data-idx="' + idx + '" aria-label="' + TX.menge + '">' +
      '<button type="button" class="mtbe-qty-btn" data-schritt="1" data-idx="' + idx + '" aria-label="' + TX.mehr + '">' + IC_PLUS + '</button></div>';
  }

  function render() {
    selectedWrap.innerHTML = '';
    // 08.10.2026 (GPT A22-003): Mit dem letzten Artikel verschwindet auch die Summe (vorher blieb sie stehen).
    if (!items.length) { selectedWrap.hidden = true; artikelField.value = ''; renderSummary(); return; }
    selectedWrap.hidden = false;
    items.forEach(function (it, idx) {
      var row = document.createElement('div');
      row.className = 'mtbe-row';
      row.setAttribute('data-idx', idx);
      var img = it.image
        ? '<img src="' + esc(it.image) + '" alt="" class="mtbe-row-img">'
        : '<span class="mtbe-row-img"></span>';
      var variantSel = '';
      if (it.variants && it.variants.length > 1) {
        variantSel = '<select class="mtbe-row-variant" data-idx="' + idx + '" aria-label="' + TX.variante + '">' +
          it.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.id === it.variantId ? ' selected' : '') + '>' + esc(v.title) + '</option>';
          }).join('') + '</select>';
      }
      // 08.10.2026 (GPT A22-004): echter Lieferstatus mit Zeit statt „Auf Lager“ für alles Bestellbare
      var avTag = statusHtml(statusFuer(it));
      if (!avTag && it.available === false) avTag = '<span class="mtbe-stock mtbe-stock--out">' + TX.nichtVerfuegbar + '</span>';
      var vendor = it.vendor ? '<span class="mtbe-row-vendor">' + esc(it.vendor) + '</span>' : '';
      row.innerHTML = img +
        '<div class="mtbe-row-main">' +
          vendor +
          '<span class="mtbe-row-title">' + esc(it.title) + '</span>' +
          '<div class="mtbe-row-pricing">' + pricingHtml(it) + '</div>' +
          ((avTag || variantSel) ? ('<div class="mtbe-row-meta">' + avTag + variantSel + '</div>') : '') +
        '</div>' +
        '<div class="mtbe-row-controls">' +
          mengeHtml(it, idx) +
          '<button type="button" class="mtbe-row-rm" data-idx="' + idx + '" aria-label="' + TX.entfernen + '">' + (IC_ENTFERNEN || TX.entfernen) + '</button>' +
        '</div>';
      selectedWrap.appendChild(row);
    });
    serialize();
    renderSummary();
  }

  function repaintPrices() {
    items.forEach(function (it, idx) {
      var row = selectedWrap.querySelector('.mtbe-row[data-idx="' + idx + '"]');
      if (!row) return;
      var pr = row.querySelector('.mtbe-row-pricing');
      if (pr) pr.innerHTML = pricingHtml(it);
    });
    renderSummary();
  }

  function renderSummary() {
    if (!summaryEl) return;
    if (!items.length) { summaryEl.hidden = true; summaryEl.innerHTML = ''; return; }
    var summe = 0, missing = false;
    items.forEach(function (it) {
      if (typeof it.price !== 'number') { missing = true; return; }
      summe += it.price * it.qty;
    });
    // 08.10.2026 (GPT A22-002): Die Summe ist Stückpreis mal Menge zum heutigen Shop-Preis und heißt deshalb „Vorläufige Summe“.
    // Sie rechnet keinen Mengenrabatt: Das Formular kennt die erste Bestellung nicht, und was am Ende gilt, steht in der Rechnung.
    // Kein Steuerbetrag mehr (vorher fest 19 %, Bücher haben 7 %). Kein Rabattcode-Hinweis mehr (Codes sind hier nicht einlösbar).
    var html = '<div class="mtbe-sum-row"><span>' + TX.summeArtikel + '</span><span>' + moneyC(summe) + '</span></div>';
    html += '<div class="mtbe-sum-row"><span>' + TX.versand + '</span><span>' + TX.keinVersand + '<small>' + TX.keinVersandKlein + '</small></span></div>';
    html += '<div class="mtbe-sum-row mtbe-sum-total"><span>' + TX.summeVorlaeufig + ' <small>' + TX.inklMwst + '</small></span><span>' + moneyC(summe) + '</span></div>';
    if (missing) html += '<p class="mtbe-sum-hinweis" style="margin:8px 0 0;font-size:14px;line-height:1.5;color:#333">' + TX.laedt + '</p>';
    // 28.10.2026 (T-719, GPT A22-002): Der Hinweis zur vorläufigen Summe steht jetzt auf der Seite (vorher nur in der Textsammlung, die Mail-Zeile behauptete ihn).
    html += '<p class="mtbe-sum-hinweis" style="margin:8px 0 0;font-size:14px;line-height:1.5;color:#333">' + TX.summeHinweis + '</p>';
    summaryEl.innerHTML = html;
    summaryEl.hidden = false;
  }

  // Klartext-Aufstellung, die mit der Anfrage an den Shop übermittelt wird
  // Artikel-Tabelle für die Kundennachricht: SKU | Artikel | Anz | Einzeln | Summe.
  // Wird von serialize() UND summaryText() genutzt, damit in der Mail nicht zwei
  // unterschiedliche Auflistungen desselben Warenkorbs stehen.
  function pad(s, n) { s = String(s == null ? '' : s); return s.length >= n ? s.slice(0, n) : s + Array(n - s.length + 1).join(' '); }
  function padL(s, n) { s = String(s == null ? '' : s); return s.length >= n ? s : Array(n - s.length + 1).join(' ') + s; }
  function itemTable() {
    var rows = items.map(function (it) {
      var hasP = typeof it.price === 'number';
      var name = it.title + (it.variantTitle && it.variantTitle !== 'Default Title' ? ' (' + it.variantTitle + ')' : '');
      return pad(it.sku || '-', 12) + ' | ' + pad(name, 42) + ' | ' + padL(it.qty, 3) +
        ' | ' + padL(hasP ? moneyPlain(it.price) : '-', 11) +
        ' | ' + padL(hasP ? moneyPlain(it.price * it.qty) : '-', 11);
    });
    var head = pad('SKU', 12) + ' | ' + pad('Artikel', 42) + ' | ' + padL('Anz', 3) +
      ' | ' + padL('Einzeln', 11) + ' | ' + padL('Summe', 11);
    return head + '\n' + Array(head.length + 1).join('-') + '\n' + rows.join('\n');
  }
  function summaryText() {
    var summe = 0;
    items.forEach(function (it) {
      if (typeof it.price !== 'number') return;
      summe += it.price * it.qty;
    });
    var txt = itemTable();
    txt += '\n\nVorläufige Summe der Anfrage (Shop-Preise von heute, ohne Mengenrabatt, inkl. MwSt.): ' + moneyPlain(summe);
    txt += '\nVersand: kein zweiter Versand (gleiche Sendung)';
    txt += '\nDem Kunden angezeigt: Summe ist vorläufig, Rabatt und Versand stehen in der Rechnung.';
    var code = (discountEl && discountEl.value || '').trim();
    if (code) txt += '\nRabattcode: ' + code;
    return txt;
  }

  function enrich(it) {
    if (!it.handle) return;
    fetch('/products/' + encodeURIComponent(it.handle) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        it.title = p.title || it.title;
        it.type = p.type || it.type || '';
        it.vendor = p.vendor || it.vendor || '';
        if (!it.image && p.featured_image) it.image = p.featured_image;
        it.variants = (p.variants || []).map(function (v) { return { id: v.id, title: v.title, available: v.available, price: v.price, sku: v.sku || '' }; });
        var sv = it.variants.filter(function (x) { return x.id === it.variantId; })[0] || it.variants[0];
        if (sv) {
          it.variantId = sv.id; it.variantTitle = sv.title; it.sku = sv.sku || '';
          if (typeof sv.price === 'number') it.price = sv.price;
          it.available = sv.available;
        } else {
          if (typeof p.price === 'number') it.price = p.price;
          if (typeof p.available === 'boolean') it.available = p.available;
        }
        render();
        holeStatus(it.handle).then(function (m) { if (m) { it.ls = m; render(); } });
      })
      .catch(function () { /* Fallback: bestehende Daten bleiben stehen */ });
  }

  function addProduct(handle, title, image) {
    if (!handle) return;
    var existing = items.filter(function (x) { return x.handle === handle; })[0];
    if (existing) { existing.qty++; render(); return; }
    var it = { handle: handle, title: title || handle, image: image || '', variants: [], variantId: null, variantTitle: '', qty: 1, price: null, type: '', vendor: '', available: null };
    items.push(it);
    render();
    enrich(it);
  }

  selectedWrap.addEventListener('click', function (e) {
    // 28.10.2026 (T-716): Plus und Minus am Mengenfeld, ohne die Zeilen neu zu zeichnen
    var sb = e.target.closest('.mtbe-qty-btn');
    if (sb) {
      var si = items[+sb.dataset.idx]; if (!si) return;
      var sn = (si.qty || 1) + (+sb.getAttribute('data-schritt'));
      si.qty = sn > 0 ? sn : 1;
      var sbox = sb.parentNode, sf = sbox.querySelector('.mtbe-row-qty'), sm = sbox.querySelector('[data-schritt="-1"]');
      if (sf) sf.value = si.qty;
      if (sm) sm.disabled = si.qty <= 1;
      serialize(); repaintPrices();
      return;
    }
    var rm = e.target.closest('.mtbe-row-rm');
    if (rm) { items.splice(+rm.dataset.idx, 1); render(); }
  });
  selectedWrap.addEventListener('input', function (e) {
    var q = e.target.closest('.mtbe-row-qty');
    if (q) { var n = parseInt(q.value, 10); items[+q.dataset.idx].qty = (n > 0 ? n : 1); var qm = q.parentNode && q.parentNode.querySelector('[data-schritt="-1"]'); if (qm) qm.disabled = items[+q.dataset.idx].qty <= 1; serialize(); repaintPrices(); }
  });
  selectedWrap.addEventListener('change', function (e) {
    var v = e.target.closest('.mtbe-row-variant');
    if (v) {
      var it = items[+v.dataset.idx];
      it.variantId = parseInt(v.value, 10);
      var sel = it.variants.filter(function (x) { return x.id === it.variantId; })[0];
      if (sel) { it.variantTitle = sel.title; it.price = sel.price; it.available = sel.available; }
      render();
    }
  });

  if (discountEl) discountEl.addEventListener('input', renderSummary);

  /* ---------- Predictive Search ---------- */
  // 28.10.2026 (T-716): Preis im Suchtreffer aus der Suchantwort (Shop-Preis); haben die Varianten verschiedene Preise, steht „ab“ davor.
  function resPreis(p) {
    var min = parseFloat(p.price_min != null ? p.price_min : p.price), max = parseFloat(p.price_max != null ? p.price_max : p.price);
    if (!isFinite(min)) return '';
    return '<span class="mtbe-res-price">' + (isFinite(max) && max > min ? TX.ab : '') + moneyC(Math.round(min * 100)) + '</span>';
  }
  function handleFromUrl(url) { var m = (url || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }

  var t = null, lastQ = '';
  function doSearch(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!prods.length) {
          results.innerHTML = '<div class="mtbe-noresult">' + TX.nichts + '</div>';
          results.hidden = false; search.setAttribute('aria-expanded', 'true');
          return;
        }
        results.innerHTML = prods.map(function (p) {
          var handle = p.handle || handleFromUrl(p.url);
          var img = p.image
            ? '<img src="' + esc(p.image) + '" alt="" class="mtbe-res-img">'
            : '<span class="mtbe-res-img"></span>';
          // 08.10.2026 (GPT A22-004): Platz für den echten Lieferstatus, er wird je Treffer nachgeladen (siehe unten)
          var stock = '<span class="mtbe-res-st" data-ls="' + esc(handle) + '">' + (p.available === false ? '<span class="mtbe-stock mtbe-stock--out">' + TX.nichtVerfuegbar + '</span>' : '') + '</span>';
          return '<button type="button" class="mtbe-res" role="option" data-handle="' + esc(handle) +
            '" data-title="' + esc(p.title) + '" data-image="' + esc(p.image || '') + '">' +
            img + '<span class="mtbe-res-main"><span class="mtbe-res-title">' + esc(p.title) + '</span><span class="mtbe-res-zeile">' + resPreis(p) + stock + '</span></span>' + (IC_PLUS ? '<span class="mtbe-res-plus" aria-hidden="true">' + IC_PLUS + '</span>' : '') + '</button>';
        }).join('');
        results.hidden = false; search.setAttribute('aria-expanded', 'true');
        Array.prototype.forEach.call(results.querySelectorAll('[data-ls]'), function (n) {
          holeStatus(n.getAttribute('data-ls')).then(function (m) { var h = m && statusHtml(m.erste); if (h && n.isConnected) n.innerHTML = h; });
        });
      })
      .catch(function () { results.hidden = true; search.setAttribute('aria-expanded', 'false'); });
  }
  search.addEventListener('input', function () {
    var q = search.value.trim();
    clearTimeout(t);
    if (q.length < 2) { results.hidden = true; results.innerHTML = ''; search.setAttribute('aria-expanded', 'false'); return; }
    t = setTimeout(function () { if (q !== lastQ) { lastQ = q; doSearch(q); } }, 250);
  });
  results.addEventListener('click', function (e) {
    var b = e.target.closest('.mtbe-res');
    if (!b) return;
    addProduct(b.dataset.handle, b.dataset.title, b.dataset.image);
    results.hidden = true; results.innerHTML = ''; search.value = ''; lastQ = '';
    search.setAttribute('aria-expanded', 'false'); search.focus();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.mtbe-picker')) { results.hidden = true; search.setAttribute('aria-expanded', 'false'); }
  });

  /* ---------- Absenden absichern ---------- */
  if (form) {
    var armed = false, armTimer = null;
    form.addEventListener('submit', function (e) {
      try { syncOrder(); serialize(); } catch (err) {}
      var note = (bodyEl && bodyEl.value || '').trim();
      if (!items.length && !note) {
        e.preventDefault();
        // 19.10.2026 (Audit W21, T17): Zeile am Knopf statt alert()
        var sb = form.querySelector('button[type="submit"]'), mz = form.querySelector('.mtbe-meldung');
        if (!mz) { mz = document.createElement('p'); mz.className = 'mtbe-meldung'; mz.setAttribute('role', 'alert'); mz.style.cssText = 'margin:8px 0 0;font-size:14px;line-height:1.4;color:#b42318'; if (sb && sb.parentNode) sb.parentNode.appendChild(mz); else form.appendChild(mz); }
        mz.textContent = TX.leer;
        return;
      }
      var mzAlt = form.querySelector('.mtbe-meldung'); if (mzAlt) mzAlt.textContent = '';
      // Bestätigung in zwei Schritten, damit keine Anfrage aus Versehen rausgeht. KEIN window.confirm (das blockt der Browser nach mehreren Klicks).
      // 08.10.2026 (GPT A22-001), 19.10.2026: Rückfall per Mail, wenn das Kundenportal nicht greift.
      var btn = form.querySelector('button[type="submit"]');
      if (items.length && !armed) {
        e.preventDefault();
        armed = true;
        if (btn) {
          if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
          btn.textContent = TX.nochmalTippen;
          btn.classList.add('is-armed');
        }
        clearTimeout(armTimer);
        armTimer = setTimeout(function () {
          armed = false;
          if (btn && btn.getAttribute('data-label')) { btn.textContent = btn.getAttribute('data-label'); btn.classList.remove('is-armed'); }
        }, 6000);
        return;
      }
      // zweiter Klick -> Aufstellung schreiben, Ergänzung merken, nativ abschicken
      try { if (bodyEl && items.length) bodyEl.value = (note ? note + '\n\n' : '') + summaryText(); } catch (err) {}
      // Entwurf zusaetzlich in sessionStorage: Schickt Shopify eine Captcha-Zwischenseite
      // dazwischen, geht der localStorage-Schreibvorgang beim Seitenwechsel unter und der
      // Kunde sieht nach dem Loesen des Captchas nirgends, dass er etwas angefragt hat.
      // Beim naechsten Laden mit contact_posted=true wird der Entwurf uebernommen.
      try {
        if (items.length) {
          var draftName = (orderField && orderField.value || '').trim();
          localStorage.setItem('mt_erg_draft', JSON.stringify({
            order: draftName, ts: Date.now(),
            items: items.map(function (it) {
              return { t: it.title, v: (it.variantTitle && it.variantTitle !== 'Default Title' ? it.variantTitle : ''), q: it.qty, img: it.image || '', ts: Date.now() };
            })
          }));
        }
      } catch (err) {}
      try {
        if (items.length) {
          var oname = (orderField && orderField.value || '').trim();
          if (oname) {
            var pend = JSON.parse(localStorage.getItem('mt_erg_pending') || '{}');
            var prev = (pend[oname] && pend[oname].items) || [];
            // ts pro Artikel: bei mehreren Ergaenzungen soll jede ihr eigenes Datum behalten,
            // statt dass ein Bestell-Zeitstempel alle ueberschreibt.
            items.forEach(function (it) {
              prev.push({ t: it.title, v: (it.variantTitle && it.variantTitle !== 'Default Title' ? it.variantTitle : ''), q: it.qty, img: it.image || '', ts: Date.now() });
            });
            pend[oname] = { ts: Date.now(), items: prev };
            localStorage.setItem('mt_erg_pending', JSON.stringify(pend));
          }
        }
      } catch (err) {}
    });
  }
  /* ---------- Auswahl für das Kundenportal (19.10.2026, Stufe 2) ----------
     Nur lesen: assets/mt-portal.js holt sich die gewählten Artikel, wenn der Portal-Dienst antwortet (Knopf „Weiter“). */
  window.mtErgaenzenAuswahl = function () {
    var pos = {}, anzeige = [], ausKorb = {};
    items.forEach(function (it) {
      if (!it.variantId) return;
      var v = String(it.variantId);
      pos[v] = (pos[v] || 0) + (it.qty || 1);
      anzeige.push({ variant_id: it.variantId, product_title: it.title, variant_title: it.variantTitle || '', image: it.image || '', handle: it.handle || '' });
      if (it.ausKorb) ausKorb[v] = true;
    });
    return {
      bestellung: (orderField && orderField.value || '').trim(),
      positionen: Object.keys(pos).map(function (v) { return { variante: v, menge: pos[v] }; }),
      anzeige: anzeige, ausKorb: ausKorb
    };
  };

  /* ---------- Inline im Konto: in die Bestellung einklinken + Warenkorb übernehmen ---------- */
  var wrap = document.getElementById('mtkn-ergaenzen');
  var orderDisplay = document.getElementById('mtbe-order-display');

  function resetPicker() {
    items = [];
    search.value = '';
    lastQ = '';
    if (results) { results.hidden = true; results.innerHTML = ''; }
    search.setAttribute('aria-expanded', 'false');
    render();
  }
  function setOrderName(name) {
    if (orderField) orderField.value = name || '';
    if (orderDisplay) orderDisplay.textContent = name ? (TX.fuerBestellung + name) : '';
  }
  function openErg(name, trigger) {
    if (!wrap) return;
    var block = (trigger && trigger.closest) ? trigger.closest('.mtkn-aw-order, .mtkn-order') : null;
    if (trigger && trigger.parentNode) { trigger.parentNode.insertBefore(wrap, trigger.nextSibling); } // Picker direkt unter den ausloesenden Knopf
    else if (block) { block.appendChild(wrap); }
    resetPicker();
    setOrderName(name);
    wrap.hidden = false;
    // 19.10.2026 (Audit W23): aria-expanded am auslösenden Knopf setzen, an allen anderen zurück
    Array.prototype.forEach.call(document.querySelectorAll('[data-mt-erg-open]'), function (o) { o.setAttribute('aria-expanded', o === trigger ? 'true' : 'false'); });
    try { wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    setTimeout(function () { try { search.focus({ preventScroll: true }); } catch (e) { search.focus(); } }, 320);
  }

  if (wrap) {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-mt-erg-open]');
      if (opener) { e.preventDefault(); openErg(opener.getAttribute('data-order') || '', opener); return; }
      var closer = e.target.closest('[data-mt-erg-close]');
      if (closer && wrap.contains(closer)) {
        wrap.hidden = true;
        // Hash mit raeumen, sonst zieht :target das Panel beim naechsten Rendern wieder auf
        // und die Seite scrollt beim Zurueck-Navigieren erneut hierher.
        if (location.hash === '#mtkn-ergaenzen') {
          try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {}
        }
        var op = document.querySelector('[data-mt-erg-open][aria-expanded="true"]');
        if (op) { op.setAttribute('aria-expanded', 'false'); try { op.focus(); } catch (err) {} }
        return;
      }
    });

    var cartBtn = document.getElementById('mtbe-cart-import');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        var orig = cartBtn.textContent;
        cartBtn.disabled = true;
        cartBtn.textContent = TX.moment;
        fetch(lsWurzel() + '/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var list = (cart && cart.items) || [];
            if (!list.length) {
              cartBtn.textContent = TX.korbLeer;
              setTimeout(function () { cartBtn.textContent = orig; cartBtn.disabled = false; }, 1800);
              return;
            }
            list.forEach(function (ci) {
              var handle = ci.handle || '';
              var existing = items.filter(function (x) { return x.handle === handle && x.variantId === ci.variant_id; })[0];
              if (existing) { existing.qty += (ci.quantity || 1); return; }
              var it = {
                handle: handle,
                title: ci.product_title || ci.title || handle,
                image: ci.image || ci.featured_image || '',
                variants: [],
                variantId: ci.variant_id || null,
                variantTitle: (ci.variant_title && ci.variant_title !== 'Default Title') ? ci.variant_title : '',
                qty: ci.quantity || 1,
                ausKorb: true,
                price: (typeof ci.original_price === 'number' ? ci.original_price : ci.price) || null,
                type: ci.product_type || '',
                vendor: ci.vendor || '',
                available: null
              };
              items.push(it);
              enrich(it);
            });
            render();
            cartBtn.textContent = TX.uebernommen;
            setTimeout(function () { cartBtn.textContent = orig; cartBtn.disabled = false; }, 1800);
          })
          .catch(function () { cartBtn.textContent = orig; cartBtn.disabled = false; });
      });
    }

    // Nach dem Absenden Panel offen lassen + hinscrollen (Bestätigung sichtbar)
    if (wrap.querySelector('[data-mt-erg-success], [data-mt-erg-error]')) {
      wrap.hidden = false;
      try { wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    }
  }

  /* ---------- Ergänzungen als "In Bearbeitung" anzeigen (clientseitig gemerkt) ---------- */
  function renderPending() {
    var pend;
    try { pend = JSON.parse(localStorage.getItem('mt_erg_pending') || '{}'); } catch (e) { return; }
    var now = Date.now(), MAXAGE = 14 * 24 * 60 * 60 * 1000, changed = false;
    function selFor(name) { return '[data-order="' + ((window.CSS && CSS.escape) ? CSS.escape(name) : name.replace(/"/g, '\\"')) + '"]'; }
    Object.keys(pend).forEach(function (name) {
      var entry = pend[name];
      if (!entry || !entry.items || !entry.items.length || (now - (entry.ts || 0) > MAXAGE)) { delete pend[name]; changed = true; return; }
      var sel = selFor(name);
      var awBlock = document.querySelector('li.mtkn-aw-order' + sel);
      // 06.08.2026: stand auf 'div.mtkn-order' - im Bestellungen-Tab ist das aber ein <a>,
      // darum wurde das Badge "Ergänzung in Bearbeitung" dort nie gesetzt. data-order macht
      // den Selektor eindeutig genug (mtkn-aw-order/mtkn-aw-addcta tragen andere Klassen).
      var ordBlock = document.querySelector('.mtkn-order' + sel);
      // Titel, die schon real in der Bestellung stehen, gelten nicht mehr als "in Bearbeitung"
      var realTitles = [];
      if (awBlock) {
        Array.prototype.forEach.call(awBlock.querySelectorAll('.mtkn-aw-item:not(.mtkn-aw-additem):not(.mtkn-aw-item--pending) .mtkn-aw-title'), function (n) {
          realTitles.push((n.textContent || '').trim().toLowerCase());
        });
      }
      var stillPending = entry.items.filter(function (it) {
        return realTitles.indexOf((it.t || '').trim().toLowerCase()) === -1;
      });
      if (!stillPending.length) { delete pend[name]; changed = true; return; }
      if (stillPending.length !== entry.items.length) { entry.items = stillPending; changed = true; }

      // Bestellungen-Tab: Badge im Kopf (dort sind die Positionen eingeklappt)
      // 06.08.2026: hiess frueher ebenfalls 'mtkn-badge--pending'. Diese Klasse gibt es aber
      // schon fuer den Zahlungsstatus "Ausstehend" - der Block hatte sie also immer, und das
      // Ergaenzungs-Badge wurde nie gesetzt. Eigene Klasse: mtkn-badge--erg.
      if (ordBlock && !ordBlock.querySelector('.mtkn-badge--erg')) {
        var bo = ordBlock.querySelector('.mtkn-order-sum .mtkn-badges');
        if (bo) bo.insertAdjacentHTML('beforeend', '<span class="mtkn-badge mtkn-badge--erg">' + TX.ergAngefragt + '</span>');
      }
      // Eigener, IMMER sichtbarer Block "Von dir dazubestellt".
      // Vorher wurden die Positionen nur ausgegraut in die Positionsliste geschoben - die ist
      // in der Uebersicht eingeklappt, also sah der Kunde nach dem Absenden nirgends, DASS er
      // ueberhaupt schon etwas angefragt hat. Der Block steht jetzt oberhalb der Positionen.
      if (awBlock && !awBlock.querySelector('.mtkn-erg-done')) {
        var box = document.createElement('div');
        box.className = 'mtkn-erg-done';
        function stamp(ts) {
          try {
            var d = new Date(ts);
            return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '. ' +
              ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + TX.uhr;
          } catch (e) { return ''; }
        }
        // Jede Ergaenzung einzeln mit eigenem Zeitpunkt - bei mehreren Anfragen muss der
        // Kunde sehen, was er WANN dazugelegt hat, nicht nur eine Sammelzeile.
        var rows = stillPending.map(function (it) {
          var label = (it.t || '') + (it.v ? ' (' + it.v + ')' : '');
          var img = it.img
            ? '<img class="mtkn-erg-done-img" src="' + esc(it.img) + '" alt="" loading="lazy">'
            : '<span class="mtkn-erg-done-img"></span>';
          var t = stamp(it.ts || entry.ts || Date.now());
          return '<li class="mtkn-erg-done-row">' + img +
            '<span class="mtkn-erg-done-tx"><span class="mtkn-erg-done-t">' + esc(label) + '</span>' +
            '<span class="mtkn-erg-done-q">' + (it.q || 1) + '&times;' + (t ? ' &middot; ' + t : '') + '</span></span>' +
            '<span class="mtkn-erg-done-tag">' + TX.angefragt + '</span></li>';
        }).join('');
        box.innerHTML =
          '<div class="mtkn-erg-done-h"><span class="mtkn-erg-done-hl">' + TX.vonDir + '</span>' +
          '<span class="mtkn-erg-done-d">' + stillPending.length + ' ' + (stillPending.length === 1 ? TX.artikelEins : TX.artikelMehr) + '</span></div>' +
          '<ul class="mtkn-erg-done-list">' + rows + '</ul>' +
          '<p class="mtkn-erg-done-note">' + TX.pendNotiz + '</p>';
        // Direkt unter die Status-Zeile, also VOR die Positionen und den Geldblock
        var anchor = awBlock.querySelector('.mtkn-aw-state') || awBlock.querySelector('.mtkn-aw-ohead');
        if (anchor && anchor.nextSibling) anchor.parentNode.insertBefore(box, anchor.nextSibling);
        else awBlock.appendChild(box);
      }
    });
    if (changed) { try { localStorage.setItem('mt_erg_pending', JSON.stringify(pend)); } catch (e) {} }
  }
  // Entwurf uebernehmen, wenn das Absenden ueber Shopifys Captcha-Zwischenseite lief und
  // der localStorage-Eintrag dabei verloren ging. Laeuft VOR renderPending().
  (function adoptDraft() {
    try {
      if (location.search.indexOf('contact_posted=true') < 0) return;
      var raw = localStorage.getItem('mt_erg_draft');
      if (!raw) return;
      var d = JSON.parse(raw);
      localStorage.removeItem('mt_erg_draft');
      if (!d || !d.order || !d.items || !d.items.length) return;
      var pend = JSON.parse(localStorage.getItem('mt_erg_pending') || '{}');
      var cur = (pend[d.order] && pend[d.order].items) || [];
      d.items.forEach(function (it) {
        var schonDa = cur.some(function (x) { return (x.t || '') === (it.t || '') && x.q === it.q; });
        if (!schonDa) cur.push(it);
      });
      pend[d.order] = { ts: d.ts || Date.now(), items: cur };
      localStorage.setItem('mt_erg_pending', JSON.stringify(pend));
    } catch (e) {}
  })();
  renderPending();
})();
